import '@dariosoft/framework'
import './$app'
import './index.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { StoreManager } from '@app/core';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
  {
    identifierPrefix: '',
    onRecoverableError: (error, info) => {
    },
  }
);
root.render(
  <React.StrictMode>
    <Provider store={StoreManager.store}><App /></Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
